import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import SectionView from "../../../layout/section/SectionView";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import {none, option, Option} from "ts-option";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import RadioButton, {IRadioButton} from "../../../../hiberUiKit/src/atoms/Buttons/RadioButton";
import Toast from "../../../helper/Toast";
import SectionSeparator from "../../../layout/section/SectionSeparator";
import Price from "../../../../model/common/Price";
import {OnFailure, OnSuccess} from "../../../../store/action/actionHelpers";
import {Dispatch} from "redux";
import {finaliseBillOfMaterials,} from "../../../../store/action/billOfMaterials/billOfMaterials";
import {connect} from "react-redux";
import {api} from "../../../../api/api";
import {BomFinalise} from "../../../../model/job/BillOfMaterialsPreviewDetails";
import Loading from "../../../ui/loading/Loading";

interface ComponentProps {
	/**
	 * On successfully finalise bom callback
	 */
	onSuccess: () => void;
	/**
	 * On modal close
	 */
	onCancel: () => void;
	/**
	 * Id of Bill of Materials
	 */
	bomId: string;
	/**
	 * Customer price from Bill of Materials
	 */
	customerPrice: Price;
	/**
	 * Installer earnings from Bill of Materials
	 */
	installerEarnings: Price;
	/**
	 * Costs difference between quote and Bill of Materials
	 */
	costsDifference: Price;
	/**
	 * Job id
	 */
	jobId: string;
}

interface DispatchProps {
	/**
	 * Finalize bill of materials
	 */
	finaliseBillOfMaterials: (bomId: string, selectedOptionData: Option<BillOfMaterialsFinaliseOptions>, jobId: string,
		onSuccess: OnSuccess, onFailure: OnFailure) => void
}

interface State {
	/**
	 * Indicates which amount should be changed on finalising Bill of Materials
	 */
	selectedFinaliseOption: Option<BillOfMaterialsFinaliseOptions>
	/**
	 * Indicates if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Adjusted prices(finalised calculations)
	 */
	bomFinalise: Option<BomFinalise[]>;
}

type Props = ComponentProps & DispatchProps;

class FinalisingBillOfMaterialsModal extends React.Component<Props, State> {
	installerEarningsRadioButton: IRadioButton = {
		label: "Adjust installer earnings, keep customer price",
		disabled: false,
		value: BillOfMaterialsFinaliseOptions.INSTALLER_EARNINGS
	};
	customerPriceRadioButton: IRadioButton = {
		label: "Adjust customer price, keep installer earnings",
		disabled: false,
		value: BillOfMaterialsFinaliseOptions.CUSTOMER_PRICE
	};


	constructor(props: Props) {
		super(props);
		this.state = {
			selectedFinaliseOption: none,
			isSubmitting: false,
			bomFinalise: none
		};
		this.getInstallerEarnings = this.getInstallerEarnings.bind(this);
		this.getCustomerPrice = this.getCustomerPrice.bind(this);
		this.onSelectRadioButton = this.onSelectRadioButton.bind(this);
	}

	componentDidMount(): void {
		api.instance.jobBillOfMaterialsApi.getFinalisedCalculations(this.props.bomId)
			.then(bomFinalise => {
				let isPriceLowerThenZero = false;
				bomFinalise.forEach(bf => {
					if (bf.values.customerPrice.amount < 0 && bf.adjustment === BillOfMaterialsFinaliseOptions.CUSTOMER_PRICE) {
						this.customerPriceRadioButton = {
							...this.customerPriceRadioButton,
							disabled: true,
							label: this.getRadioButtonLabelWithError(this.customerPriceRadioButton, "Customer price")
						};
						isPriceLowerThenZero = true;
						return
					}
					if (bf.values.installerEarnings.amount < 0
						&& bf.adjustment === BillOfMaterialsFinaliseOptions.INSTALLER_EARNINGS) {
						this.installerEarningsRadioButton = {
							...this.installerEarningsRadioButton,
							disabled: true,
							label: this.getRadioButtonLabelWithError(this.installerEarningsRadioButton, "Installer earnings")
						};
						isPriceLowerThenZero = true
					}
				});
				this.setState({
					bomFinalise: option(bomFinalise),
					selectedFinaliseOption: isPriceLowerThenZero ? none : this.state.selectedFinaliseOption
				});
			})
			.catch(error => {
				notifyBugsnagAndShowToast(error, "Bill of Materials finalised calculations");
			});
	}


	render() {
		const installerEarningsChecked = this.state.selectedFinaliseOption
			.map(opt => opt === BillOfMaterialsFinaliseOptions.INSTALLER_EARNINGS).getOrElse(false);
		const customerPriceChecked = this.state.selectedFinaliseOption
			.map(opt => opt === BillOfMaterialsFinaliseOptions.CUSTOMER_PRICE).getOrElse(false);
		const amountCssClass = this.props.costsDifference.amount > 0 ? 't-green-color' : 'has-error';
		return (
			<Modal onCloseClicked={this.props.onCancel} title={"Finalise customer invoice changes"} autoWidth={true}>
				<div className={"job-bill-of-materials_finalise"}>
					<SectionView>
						<p>There is a cost difference of&nbsp;
							<b className={amountCssClass}>
								{this.props.costsDifference.format()}
							</b>. Please choose an option to finalise customer's invoice:
						</p>
						<div>
							<RadioButton radioButton={this.installerEarningsRadioButton}
										 onChange={this.onSelectRadioButton}
										 checked={installerEarningsChecked}/>
							<RadioButton radioButton={this.customerPriceRadioButton}
										 onChange={this.onSelectRadioButton}
										 checked={customerPriceChecked}/>
						</div>

						{this.state.selectedFinaliseOption.map(finaliseOption => (
							<div>
								<SectionSeparator style={{margin: "24px 0"}}/>
								<Loading isLoading={this.state.bomFinalise.isEmpty}>
									<div className="c-common-info_row-inner-container">
										<div className="job-bill-of-materials_info-row-narrow-item">
											<div className="c-common-info_row-item_label">Original</div>
											<div className="c-common-info_row-item_value-large">
												{this.props.installerEarnings.format()}
											</div>
											<div className="c-common-info_row-item_label-bottom">
												Installer earnings
											</div>
										</div>
										<div className="job-bill-of-materials_info-row-narrow-item">
											<div className="c-common-info_row-item_label">&nbsp;</div>
											<div className="c-common-info_row-item_value-large">
												{this.props.customerPrice.format()}
											</div>
											<div className="c-common-info_row-item_label-bottom">
												Customer price
											</div>
										</div>
										<div className="job-bill-of-materials_info-row-narrow-item">
											<div className="c-common-info_row-item_label">&nbsp;</div>
											<i className={"fa fa-fw fa-arrow-right"}/>
										</div>
										<div className="job-bill-of-materials_info-row-narrow-item">
											<div className="c-common-info_row-item_label">Finalised</div>
											<div className="c-common-info_row-item_value-large">
												<span className={finaliseOption ===
												BillOfMaterialsFinaliseOptions.INSTALLER_EARNINGS ? amountCssClass : ""}>
													{this.getInstallerEarnings(finaliseOption)}
												</span>
											</div>
											<div className="c-common-info_row-item_label-bottom">
												Installer earnings
											</div>
										</div>
										<div className="job-bill-of-materials_info-row-narrow-item">
											<div className="c-common-info_row-item_label">&nbsp;</div>
											<div className="c-common-info_row-item_value-large">
												<span className={finaliseOption ===
												BillOfMaterialsFinaliseOptions.CUSTOMER_PRICE ? amountCssClass : ""}>
													{this.getCustomerPrice(finaliseOption)}
												</span>
											</div>
											<div className="c-common-info_row-item_label-bottom">
												Customer price
											</div>
										</div>
									</div>
								</Loading>
							</div>
						)).orNull}
					</SectionView>
					<SectionSeparator style={{marginBottom: "30px"}}/>
					<FormButtonsView align={"right"}>
						<ButtonTertiary onClick={this.props.onCancel}
										label={"Cancel"}
										disabled={this.state.isSubmitting}/>
						<ButtonPrimary onClick={this.finaliseBillOfMaterials}
									   label={"Finish"}
									   disabled={this.state.selectedFinaliseOption.isEmpty}
									   isLoading={this.state.isSubmitting}/>
					</FormButtonsView>
				</div>
			</Modal>
		);
	}

	onSelectRadioButton(checked: boolean, buttonOption: IRadioButton) {
		if (checked) {
			const value: BillOfMaterialsFinaliseOptions = buttonOption.value as BillOfMaterialsFinaliseOptions;
			this.setState({selectedFinaliseOption: option(value)});
		}
	}

	getInstallerEarnings(option: BillOfMaterialsFinaliseOptions): string {
		const [bomFinalise] = this.state.bomFinalise.getOrElse([]).filter(bf => bf.adjustment === option);
		return bomFinalise && bomFinalise.values.installerEarnings.format();
	}

	getCustomerPrice(option: BillOfMaterialsFinaliseOptions): string {
		const [bomFinalise] = this.state.bomFinalise.getOrElse([]).filter(bf => bf.adjustment === option);
		return bomFinalise && bomFinalise.values.customerPrice.format();
	}

	finaliseBillOfMaterials = () => {
		const selectedOptionData = this.state.selectedFinaliseOption;
		this.setState({isSubmitting: true}, () => {
			this.props.finaliseBillOfMaterials(this.props.bomId, selectedOptionData, this.props.jobId,
				() => {
					Toast.success("Bill has been generated.", "Bill of Materials");
					this.props.onSuccess();
				},
				(error) => {
					this.setState({isSubmitting: false});
					notifyBugsnagAndShowToast(error, 'Finalise Bill of Materials');
				});
		});
	};

	getRadioButtonLabelWithError(radiobutton: IRadioButton, label: string) {
		return (
			<>
				{radiobutton.label}
				<span className={"has-error"}>
					<strong>{label}</strong> cannot be lower than 0
				</span>
			</>
		)
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		finaliseBillOfMaterials: (bomId: string, selectedOptionData: Option<BillOfMaterialsFinaliseOptions>, jobId: string,
			onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			finaliseBillOfMaterials(bomId, selectedOptionData, jobId, onSuccess, onFailure)
		)
	}
}

export default connect(null, mapDispatchToProps)(FinalisingBillOfMaterialsModal);

export enum BillOfMaterialsFinaliseOptions {
	INSTALLER_EARNINGS = 'INSTALLER_EARNINGS',
	CUSTOMER_PRICE = 'CUSTOMER_PRICE',
}
